module.exports = __webpack_public_path__ + "static/img/shuzihuayulu_03.e298b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/digitization/shuzihuayulu_03.png
// module id = P++k
// module chunks = 0